/*
 * AUTOGENERATED - DON'T EDIT
 * Your edits in this file will be overwritten in the next build!
 * Modify the docusaurus.config.js file at your site's root instead.
 */
export default {
  "title": "React DayPicker",
  "tagline": "Date Picker Component for React",
  "url": "https://react-day-picker.js.org",
  "baseUrl": "/",
  "favicon": "images/favicon.png",
  "organizationName": "gpbl",
  "projectName": "react-day-picker",
  "trailingSlash": false,
  "clientModules": [
    "/home/runner/work/react-day-picker/react-day-picker/dist/style.css"
  ],
  "themeConfig": {
    "metadata": [
      {
        "name": "twitter:site",
        "content": "@gpblv"
      },
      {
        "name": "twitter:title",
        "content": "React DayPicker"
      },
      {
        "name": "twitter:description",
        "content": "DayPicker is a date picker component for React, written in TypeScript."
      },
      {
        "name": "og:description",
        "content": "DayPicker is a date picker component for React, written in TypeScript."
      },
      {
        "name": "description",
        "content": "DayPicker is a date picker component for React, written in TypeScript."
      },
      {
        "name": "keywords",
        "content": "date picker, react component, calendar component, react datepicker, daypicker, react day picker, date-fns date picker, typescript date picker"
      }
    ],
    "docs": {
      "sidebar": {
        "hideable": false,
        "autoCollapseCategories": false
      },
      "versionPersistence": "localStorage"
    },
    "image": "images/og-image.png",
    "navbar": {
      "title": "React DayPicker",
      "logo": {
        "alt": "DayPicker Logo",
        "src": "images/logo.png"
      },
      "hideOnScroll": true,
      "items": [
        {
          "to": "start",
          "label": "Documentation",
          "position": "left"
        },
        {
          "to": "reference",
          "label": "API Reference",
          "position": "left"
        },
        {
          "to": "development",
          "label": "Development",
          "position": "left"
        },
        {
          "type": "docsVersionDropdown",
          "position": "right",
          "dropdownActiveClassDisabled": true,
          "dropdownItemsBefore": [
            {
              "to": "changelog",
              "label": "Changelog"
            }
          ],
          "dropdownItemsAfter": [
            {
              "href": "https://react-day-picker-v7.netlify.app",
              "label": "v7.4.10 (older version)"
            }
          ]
        },
        {
          "href": "https://github.com/gpbl/react-day-picker",
          "position": "right",
          "className": "header-github-link",
          "aria-label": "GitHub repository"
        }
      ]
    },
    "prism": {
      "theme": {
        "plain": {
          "color": "#393A34",
          "backgroundColor": "#f6f8fa"
        },
        "styles": [
          {
            "types": [
              "comment",
              "prolog",
              "doctype",
              "cdata"
            ],
            "style": {
              "color": "#999988",
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "namespace"
            ],
            "style": {
              "opacity": 0.7
            }
          },
          {
            "types": [
              "string",
              "attr-value"
            ],
            "style": {
              "color": "#e3116c"
            }
          },
          {
            "types": [
              "punctuation",
              "operator"
            ],
            "style": {
              "color": "#393A34"
            }
          },
          {
            "types": [
              "entity",
              "url",
              "symbol",
              "number",
              "boolean",
              "variable",
              "constant",
              "property",
              "regex",
              "inserted"
            ],
            "style": {
              "color": "#36acaa"
            }
          },
          {
            "types": [
              "atrule",
              "keyword",
              "attr-name",
              "selector"
            ],
            "style": {
              "color": "#00a4db"
            }
          },
          {
            "types": [
              "function",
              "deleted",
              "tag"
            ],
            "style": {
              "color": "#d73a49"
            }
          },
          {
            "types": [
              "function-variable"
            ],
            "style": {
              "color": "#6f42c1"
            }
          },
          {
            "types": [
              "tag",
              "selector",
              "keyword"
            ],
            "style": {
              "color": "#00009f"
            }
          }
        ]
      },
      "darkTheme": {
        "plain": {
          "color": "#d6deeb",
          "backgroundColor": "#011627"
        },
        "styles": [
          {
            "types": [
              "changed"
            ],
            "style": {
              "color": "rgb(162, 191, 252)",
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "deleted"
            ],
            "style": {
              "color": "rgba(239, 83, 80, 0.56)",
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "inserted",
              "attr-name"
            ],
            "style": {
              "color": "rgb(173, 219, 103)",
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "comment"
            ],
            "style": {
              "color": "rgb(99, 119, 119)",
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "string",
              "url"
            ],
            "style": {
              "color": "rgb(173, 219, 103)"
            }
          },
          {
            "types": [
              "variable"
            ],
            "style": {
              "color": "rgb(214, 222, 235)"
            }
          },
          {
            "types": [
              "number"
            ],
            "style": {
              "color": "rgb(247, 140, 108)"
            }
          },
          {
            "types": [
              "builtin",
              "char",
              "constant",
              "function"
            ],
            "style": {
              "color": "rgb(130, 170, 255)"
            }
          },
          {
            "types": [
              "punctuation"
            ],
            "style": {
              "color": "rgb(199, 146, 234)"
            }
          },
          {
            "types": [
              "selector",
              "doctype"
            ],
            "style": {
              "color": "rgb(199, 146, 234)",
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "class-name"
            ],
            "style": {
              "color": "rgb(255, 203, 139)"
            }
          },
          {
            "types": [
              "tag",
              "operator",
              "keyword"
            ],
            "style": {
              "color": "rgb(127, 219, 202)"
            }
          },
          {
            "types": [
              "boolean"
            ],
            "style": {
              "color": "rgb(255, 88, 116)"
            }
          },
          {
            "types": [
              "property"
            ],
            "style": {
              "color": "rgb(128, 203, 196)"
            }
          },
          {
            "types": [
              "namespace"
            ],
            "style": {
              "color": "rgb(178, 204, 214)"
            }
          }
        ]
      },
      "additionalLanguages": [],
      "magicComments": [
        {
          "className": "theme-code-block-highlighted-line",
          "line": "highlight-next-line",
          "block": {
            "start": "highlight-start",
            "end": "highlight-end"
          }
        }
      ]
    },
    "algolia": {
      "appId": "N44150BS2A",
      "apiKey": "42c559dd71da40a168be6f6d81d2bbbc",
      "indexName": "react-day-picker-js",
      "contextualSearch": true,
      "searchPagePath": "search",
      "searchParameters": {}
    },
    "colorMode": {
      "defaultMode": "light",
      "disableSwitch": false,
      "respectPrefersColorScheme": true
    },
    "tableOfContents": {
      "minHeadingLevel": 2,
      "maxHeadingLevel": 3
    }
  },
  "presets": [
    [
      "@docusaurus/preset-classic",
      {
        "docs": {
          "sidebarPath": "/home/runner/work/react-day-picker/react-day-picker/website/docusaurus.sidebars.js",
          "routeBasePath": "/",
          "breadcrumbs": false,
          "lastVersion": "current",
          "editUrl": "https://github.com/gpbl/react-day-picker/edit/main/website/",
          "versions": {
            "current": {
              "path": "/",
              "label": "v8.10.2"
            }
          }
        },
        "gtag": {
          "trackingID": "UA-68185118-1"
        },
        "theme": {
          "customCss": "/home/runner/work/react-day-picker/react-day-picker/website/src/custom.css"
        }
      }
    ]
  ],
  "plugins": [
    null,
    [
      "docusaurus-plugin-typedoc",
      {
        "entryPoints": [
          "../src/index.ts"
        ],
        "tsconfig": "../tsconfig.build.json",
        "allReflectionsHaveOwnDocument": true,
        "entryDocument": "reference",
        "out": "./api",
        "hideBreadcrumbs": true,
        "hideInPageTOC": true,
        "indexTitle": "Exports",
        "publicPath": "/api/"
      }
    ]
  ],
  "baseUrlIssueBanner": true,
  "i18n": {
    "defaultLocale": "en",
    "path": "i18n",
    "locales": [
      "en"
    ],
    "localeConfigs": {}
  },
  "onBrokenLinks": "throw",
  "onBrokenMarkdownLinks": "warn",
  "onDuplicateRoutes": "warn",
  "staticDirectories": [
    "static"
  ],
  "customFields": {},
  "themes": [],
  "scripts": [],
  "headTags": [],
  "stylesheets": [],
  "titleDelimiter": "|",
  "noIndex": false,
  "markdown": {
    "mermaid": false
  }
};
